// removed by extract-text-webpack-plugin
module.exports = {"component":"_1P3-Afzs _3vV4dgqW _1uSaxYl4","title":"_2TH7lY1E aMrxQIjl _1lfjmnJU","body":"_3YTS-Hfs _3Jr8Ub72 _391P90pM","line":"_2amvIhpj _26a3TGVU _30iHi-cz","bar":"_1G5HF4SC _30iHi-cz"};


/*****************
 ** WEBPACK FOOTER
 ** ./site/heading.scss
 ** module id = 8
 ** module chunks = 0
 **/